'use strict';

/**
 *
 * @name: remindMe
 *
 */

function RemindMeDirective(
  $rootScope,
  apiSubscriptionsService,
  $location,
  nnModalsService,
  $timeout) {

  'ngInject';

  return {
    restrict: 'A',
    scope: {
      post: '=remindMe'
    },
    link: function(scope, element) {

      var rootWatchers = {};

      element.on('click', function() {

        var post = scope.post;

        if (true) {

          $rootScope.remindMe = true;
          $rootScope.remindMePost = post;

          if ($rootScope.profile) {

            nnModalsService.showModal('confirm');
            setBookmark();
            $rootScope.notMyFirstTime = true;
          } else {

            rootWatchers.profile = $rootScope.$watch('profile', function(newVal) {

              if (newVal && $rootScope.remindMe) {

                setBookmark();
                rootWatchers.profile();
              }
            });

            nnModalsService.showModal('login')

            $timeout(function() {

              nnModalsService.showModal('login');
            });
          }
        }
      });

      function setBookmark() {

        if ($rootScope.profile.subscriptions.indexOf($rootScope.remindMePost.id) === -1) {

          apiSubscriptionsService
            .setSubscription($rootScope.remindMePost.id, 'post')
            .then(function() {

              $rootScope.profile.subscriptions.push($rootScope.remindMePost.id);
            });
        }
      }

      function _onDestroy() {

        scope.$on('$destroy', function() {

          Object.keys(rootWatchers)
            .forEach(function(killWatcherKey) {

              rootWatchers[killWatcherKey]();
            });
        });
      }

      _onDestroy();
    }
  };
}

export default RemindMeDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-remind-me.directive.js